import { FieldValues, UseFormSetValue, UseFormWatch } from '@missionlabs/react'
import { OutOfHoursRedirectInternal, UserCallRoute } from '@missionlabs/types'
import { absolveInternalRedirectData } from 'features/admin/pages/utils/redirect'
import { useCallback, useMemo } from 'react'

export const useOutOfHoursMethods = <T extends FieldValues>(
    watch: UseFormWatch<T>,
    setValue: UseFormSetValue<T>
) => {
    const {
        callRoute: { outOfHours },
        outOfHoursRedirectInternal,
        outOfHoursRedirect,
        outOfHoursVoicemail
    } = watch()

    const callRoute = useMemo(
        () => ({ outOfHours, outOfHoursRedirectInternal, outOfHoursRedirect, outOfHoursVoicemail }),
        [outOfHours, outOfHoursRedirect, outOfHoursRedirectInternal, outOfHoursVoicemail]
    )

    const updateValues = useCallback(
        (
            key: 'outOfHoursRedirectInternal' | 'outOfHoursRedirect' | 'outOfHoursVoicemail',
            update: Partial<UserCallRoute>
        ) => {
            const {
                outOfHours,
                outOfHoursRedirect = {},
                outOfHoursRedirectInternal = {},
                outOfHoursVoicemail = {}
            } = update
            const options = { shouldDirty: true }

            setValue('callRoute.outOfHours', outOfHours, options)

            switch (key) {
                case 'outOfHoursRedirectInternal': {
                    if (callRoute.outOfHours === 'redirect_internal') {
                        const updateRedirectInternal = outOfHoursRedirectInternal ?? {}
                        const data = { ...watch(key), ...updateRedirectInternal }
                        const updateData = absolveInternalRedirectData(data, updateRedirectInternal)
                        setValue(key, updateData as OutOfHoursRedirectInternal, options)
                    }
                    break
                }
                case 'outOfHoursRedirect': {
                    if (callRoute.outOfHours === 'redirect') {
                        setValue(key, { ...watch(key), ...outOfHoursRedirect }, options)
                    }
                    break
                }
                case 'outOfHoursVoicemail': {
                    setValue(key, { ...watch(key), ...outOfHoursVoicemail }, options)
                    break
                }
                default:
                    break
            }
        },
        [callRoute.outOfHours, setValue, watch]
    )

    return { callRoute, updateValues }
}
